// src/hooks/useHydrateModuleFromUrl.ts
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { setActiveModuleInRedux } from "../DesignTab/designSlice";
import { ACTIVE_MODULE_KEYS, IActiveModuleKey } from "../DesignTab/GlobalDesignBar/designModules";

export const useHydrateModuleFromUrl = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Støtter både ?module= og ?mod=
    const moduleParam = searchParams.get("module") ?? searchParams.get("mod");
    console.log(moduleParam);
    if (!moduleParam) return;

    const key = moduleParam.toUpperCase() as IActiveModuleKey;

    // Sikrer at vi bare aksepterer gyldige moduler
    if (!ACTIVE_MODULE_KEYS.includes(key)) return;

    dispatch(setActiveModuleInRedux(key));
  }, [dispatch, searchParams]);
};
